import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "layout-2-col-xs",
  "use": "layout-2-col-xs-usage",
  "viewBox": "0 0 25 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 25 24\" id=\"layout-2-col-xs\"><path fill=\"currentColor\" fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21 5H4c-.5 0-1 .4-1 1v12c0 .5.5 1 1 1h17c.6 0 1-.5 1-1V6c0-.6-.4-1-1-1ZM5 17V7h2.5v10H5Zm15 0H9.5V7H20v10Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol